// @flow

import { observer } from "mobx-react";
import * as React from "react";

import "./PasswordConfirmation.scss";

type Props = {
    password: string
};

@observer
export default class PasswordConfirmation extends React.Component<Props> {
    input: ?HTMLInputElement;

    handleChange = (event: SyntheticInputEvent<>) => {
        const input = this.input;
        if (!input) return;

        const value = event.target.value;
        if (value !== this.props.password) {
            input.setCustomValidity("The password does not match");
        } else {
            input.setCustomValidity("");
        }
    };

    render() {
        return (
            <input
                type="password"
                id="password_confirmation"
                name="password_confirmation"
                className="PasswordConfirmation form-control"
                placeholder="Confirm your password"
                onChange={this.handleChange}
                ref={element => (this.input = element)}
                required
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/PasswordConfirmation/PasswordConfirmation.js